import { defineComponent as v, createElementBlock as s, openBlock as o, createCommentVNode as r, createElementVNode as y, renderSlot as i, createTextVNode as n, toDisplayString as p, resolveComponent as h, createVNode as $, computed as j, createBlock as w, mergeProps as g, withCtx as c, resolveDynamicComponent as N, createSlots as O, renderList as V } from "vue";
import { v as B } from "./vsButton-BlFL21k0.mjs";
import { _ as k } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
import { v as A } from "./vsPreloader-DE9TMol9.mjs";
const P = v({
  name: "vs-modal-alert",
  components: {
    vsButton: B
  },
  emits: ["confirm"],
  props: {
    params: {
      type: Object,
      default: () => {
      }
    },
    close: {
      type: Function,
      default: () => {
      }
    },
    acceptText: {
      type: String,
      default: ""
    },
    buttonless: {
      type: Boolean,
      default: !1
    },
    closable: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, { attrs: t }) {
    return {};
  }
}), D = {
  key: 0,
  class: "text-2xl font-bold mb-4"
}, E = { class: "flex-grow overflow-y-auto text-on-surface" };
function F(e, t, d, m, b, C) {
  return o(), s("div", null, [
    e.$slots.title || e.params && e.params.title ? (o(), s("div", D, [
      i(e.$slots, "title"),
      n(" " + p(e.params && e.params.title), 1)
    ])) : r("", !0),
    y("div", E, [
      i(e.$slots, "default", { params: e.params }),
      n(" " + p(e.params && e.params.content), 1)
    ])
  ]);
}
const z = /* @__PURE__ */ k(P, [["render", F]]), L = v({
  name: "vs-modal-confirm",
  components: {
    vsButton: B
  },
  props: {
    params: {
      type: Object,
      default: () => {
      }
    },
    close: {
      type: Function,
      default: () => {
      }
    }
  },
  emits: ["confirm", "cancel"],
  setup(e, { attrs: t }) {
    return {};
  }
}), q = {
  key: 0,
  class: "mr-8 text-2xl font-bold mb-4"
}, G = { class: "flex-grow overflow-y-auto text-on-surface" };
function H(e, t, d, m, b, C) {
  return o(), s("div", null, [
    e.$slots.title || e.params && e.params.title ? (o(), s("div", q, [
      i(e.$slots, "title"),
      n(" " + p(e.params && e.params.title), 1)
    ])) : r("", !0),
    y("div", G, [
      i(e.$slots, "default", { params: e.params }),
      n(" " + p(e.params && e.params.content), 1)
    ])
  ]);
}
const I = /* @__PURE__ */ k(L, [["render", H]]), J = v({
  name: "vs-modal-alert",
  components: {
    vsPreloader: A
  },
  props: {
    params: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(e) {
    return {};
  }
}), K = {
  key: 0,
  class: "text-center text-2xl font-bold mb-6"
}, Q = { class: "flex justify-center" };
function R(e, t, d, m, b, C) {
  const a = h("vs-preloader");
  return o(), s("div", null, [
    e.$slots.title || e.params && e.params.title ? (o(), s("div", K, [
      i(e.$slots, "title"),
      n(" " + p(e.params && e.params.title), 1)
    ])) : r("", !0),
    y("div", Q, [
      $(a, {
        class: "text-center",
        size: 48
      })
    ])
  ]);
}
const U = /* @__PURE__ */ k(J, [["render", R]]), W = v({
  name: "vs-modal",
  components: {
    vsModalAlert: z,
    vsModalConfirm: I,
    vsModalPreloader: U,
    vsButton: B
  },
  props: {
    buttonless: {
      type: Boolean,
      default: !1
    },
    fullScreen: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "alert"
    },
    contentClass: {
      type: String,
      default: "alert"
    },
    closable: {
      type: Boolean,
      default: !0
    },
    noCloseButton: {
      type: Boolean,
      default: !1
    },
    acceptText: {
      type: String,
      default: ""
    }
  },
  inheritAttrs: !1,
  emits: ["opened", "close", "confirm", "cancel"],
  setup(e, { emit: t }) {
    const d = j(() => `vs-modal-${e.type}`), m = j(() => e.type !== "preloader" && e.closable);
    return { currentModal: d, canClose: m };
  }
}), X = { key: 1 }, Y = {
  key: 0,
  class: "flex justify-end px-2 mt-2"
}, Z = { key: 2 }, _ = { class: "flex-shrink-0 flex justify-end items-center pt-4 space-x-2" };
function x(e, t, d, m, b, C) {
  const a = h("vs-button"), T = h("vue-final-modal");
  return o(), w(T, g(e.$attrs, {
    classes: "flex justify-center pt-4 items-center bg-shadow/50 backdrop-blur-sm relativer",
    "content-class": `relative flex flex-col max-h-[calc(100%-4em)] w-11/12 mx-4 p-4 mt-safe border rounded-xl bg-white ${e.fullScreen ? "" : e.type === "preloader" ? "sm:max-w-sm" : "sm:max-w-xl"} ${e.contentClass}`,
    "esc-to-close": e.canClose,
    "click-to-close": e.canClose,
    onOpened: t[2] || (t[2] = (u) => e.$emit("opened")),
    onClosed: t[3] || (t[3] = (u) => e.$emit("close"))
  }), {
    default: c(({ params: u, close: l }) => [
      !e.noCloseButton && e.closable && e.canClose || e.type === "alert" && e.closable ? (o(), w(a, {
        key: 0,
        class: "absolute -right-3 sm:-right-7 -top-7 !rounded-full !h-14 !w-14 border-4 !px-0 justify-center border-white",
        kind: "primary",
        "icon-name": "uis:multiply",
        onClick: l
      }, null, 8, ["onClick"])) : r("", !0),
      (o(), w(N(e.currentModal), g(e.$attrs, {
        params: u,
        close: l,
        acceptText: e.acceptText,
        class: "overflow-y-auto",
        onConfirm: t[0] || (t[0] = (f) => e.$emit("confirm")),
        onCancel: t[1] || (t[1] = (f) => e.$emit("cancel"))
      }), O({ _: 2 }, [
        V(e.$slots, (f, S) => ({
          name: S,
          fn: c((M) => [
            i(e.$slots, S, g(M, { close: l }))
          ])
        }))
      ]), 1040, ["params", "close", "acceptText"])),
      e.type === "alert" ? (o(), s("div", X, [
        e.buttonless ? r("", !0) : (o(), s("div", Y, [
          $(a, {
            class: "w-1/3",
            kind: "primary",
            onClick: l
          }, {
            default: c(() => [
              n(p(e.acceptText ? e.acceptText : "Aceptar"), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]))
      ])) : e.type === "confirm" ? (o(), s("div", Z, [
        y("div", _, [
          $(a, {
            kind: "surface",
            onClick: (f) => {
              e.$emit("cancel"), l();
            }
          }, {
            default: c(() => t[4] || (t[4] = [
              n("Cancelar")
            ])),
            _: 2
          }, 1032, ["onClick"]),
          $(a, {
            kind: u.kind || "primary",
            onClick: (f) => {
              e.$emit("confirm"), l();
            }
          }, {
            default: c(() => t[5] || (t[5] = [
              n("Confirmar")
            ])),
            _: 2
          }, 1032, ["kind", "onClick"])
        ])
      ])) : r("", !0)
    ]),
    _: 3
  }, 16, ["content-class", "esc-to-close", "click-to-close"]);
}
const ne = /* @__PURE__ */ k(W, [["render", x]]);
export {
  ne as v
};
//# sourceMappingURL=vsModal-BLdVBDEF.mjs.map
